import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import Select from '../../../Select/Select';
import PropTypes from 'prop-types';
import FieldWrap from '../FieldWrap/FieldWrap';

var SelectInputComponentField =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectInputComponentField, _Component);

  function SelectInputComponentField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectInputComponentField);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectInputComponentField)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.onChange = function (selectedData) {
      var _this$props = _this.props,
          input = _this$props.input,
          handleChange = _this$props.handleChange;
      var newObject = {};

      if (selectedData && selectedData.value) {
        newObject.value = input.value['value'];
        newObject.currency = selectedData.value;
      } else if (selectedData && selectedData.target) {
        selectedData.stopPropagation();
        newObject.value = selectedData.target.value;
        newObject.currency = input.value['currency'];
      }

      input.onChange(newObject);
      handleChange(input.name, newObject);
    }, _temp));
  }

  _createClass(SelectInputComponentField, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          input = _this$props2.input,
          label = _this$props2.label,
          values = _this$props2.values,
          placeholder = _this$props2.placeholder,
          meta = _this$props2.meta,
          _this$props2$displayN = _this$props2.displayNotes,
          displayNotes = _this$props2$displayN === void 0 ? '' : _this$props2$displayN;
      var options = values.length && values.map(function (value) {
        return {
          value: value.title,
          label: value.title
        };
      });
      return React.createElement('div', {
        className: 'form-group SelectInputComponentField'
      }, React.createElement(FieldWrap, {
        meta: meta,
        displayNotes: displayNotes
      }, React.createElement('div', {
        className: 'SelectDiv'
      }, React.createElement('label', null, 'Currency'), React.createElement(Select, {
        value: input.value && input.value['currency'],
        options: options,
        onChange: this.onChange
      })), React.createElement('div', {
        className: 'InputDiv'
      }, React.createElement('label', null, label), React.createElement('input', {
        value: input.value && input.value['value'],
        onChange: this.onChange,
        className: 'form-control',
        type: 'number',
        placeholder: placeholder
      }))));
    }
  }]);

  return SelectInputComponentField;
}(Component);

SelectInputComponentField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.object.isRequired,
  displayNotes: PropTypes.string,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  meta: PropTypes.object.isRequired
};
export default SelectInputComponentField;